<template>
  <div>
    <Chat />
  </div>
</template>

<script>
import Chat from "@/widget/chat.vue";

export default {
  name: "AdminNachrichten",
  components: {
    Chat,
  },
};
</script>

<style></style>
